function AboutMe() {
    return (
      <div id="about_author" className="about_author">
          <div className="about_author__photo"></div>
          <div className="about_author__text">
              <h1 className='about_author__title'>O mnie</h1>
              <article className="about_author__description">Nazywam się Damian Zawadzki i jestem studentem Grafiki na Europejskim Wydziale Sztuk uczelni Vistula.
                    W 2021 obroniłem licencjat pod tytułem: "Yokai - seria obrazów w autorski sposób przedstawiająca bohaterów japońskiej mitologii".
                    W 2020 roku odkryłem kanały YouTube takie, jak Hello Roman, oraz Samuraja Programowania i zaraziłem się pasją do programowania front-endowego. 
                    Ta zaJAVkA poskutkowała tym, że w roku 2022 ukończyłem kurs CodersLab, którego projektem zaliczeniowym jest niniejsza aplikacja.
                    W swoich projektach poza implemntacją logiki, dbam również o design projektu. 
                    Sama mechanika to za mało aby przyciągnąć klienta, bowiem wszyscy jesteśmy wzrokowcami.
                    Animacje i ogólna estetyka są zatem równie ważne jak skrypty.
                    Oczywiście, nie można przesadzać również w drugą stronę. 
                    Kluczem do sukcesu i zadowolenia klienta jest znalezienie balansu pomiędzy dobrym designem, a mechaniką.
              </article> 
          </div>
      </div>
    );
  }
  
  export default AboutMe;